// **Redux Imports
import { createSlice } from '@reduxjs/toolkit'

// **Utils Imports
import {
  getUserDetails,
  getUserWorkspaceId,
  setUserWorkspaceId
} from '../../../utils/utils'

const userData = getUserDetails()
const localWorkspace = getUserWorkspaceId()

export const workspaceSlice = createSlice({
  name: 'workspace',
  initialState: {
    workspaces: [],
    selectedWorkspace: localWorkspace
      ? { id: parseInt(localWorkspace) }
      : Object.keys(userData?.workspaces || {})?.length > 0
      ? { id: parseInt(Object.keys(userData?.workspaces || {})?.[0]) }
      : null,
    workspaceTableFilters: { query: '', page: 0, pageSize: 50 },
    publishPermission: false
  },
  reducers: {
    setWorkspaces(state, action) {
      state.workspaces = action.payload.workspaces
    },
    setSelectedWorkspace(state, action) {
      const workspace = action.payload ? parseInt(action.payload) : null
      setUserWorkspaceId(workspace)
      state.selectedWorkspace = { id: workspace }
    },
    setWorkspaceTableFilters(state, action) {
      state.workspaceTableFilters = action.payload
    },
    resetWorkspaceTableFilters(state) {
      state.workspaceTableFilters = { query: '', page: 0, pageSize: 50 }
    },
    setPublishPermission(state, action) {
      state.publishPermission = action.payload
    }
  }
})

export const {
  setWorkspaces,
  setSelectedWorkspace,
  setWorkspaceTableFilters,
  resetWorkspaceTableFilters,
  setPublishPermission
} = workspaceSlice.actions

export default workspaceSlice.reducer
